import React, { Component } from "react";
import { Modal, Button, Form, Image, Alert } from "react-bootstrap";
import { login, updateAccount, register } from "../Services";
import { getHash } from "./commons/Functions";
import { toast } from "react-toastify";

class Login extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modalShowErr: false,
      modalErrMsg: "Incorrect username or password!!!",
      username: "",
      password: "",
    };
    this.baseState = this.state;
  }

  componentWillUnmount() {
    this.setState(this.baseState);
  }

  handleChange = (type) => (event) => {
    let value = event;
    if (event.target) {
      value = event.target.value;
    }
    this.setState({ [type]: value });
  };

  handleSubmit = (event) => {
    this.setState({ modalShowErr: false });
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      login({
        username: this.state.username,
        password: getHash(this.state.password),
      })
        .then((res) => {
          if (res.enabled === false) {
            if (res.loginCount === 0) {
              toast.error("Please confirm your email !");
            } else {
              toast.error("Oh snap! Your account is disabled !");
            }
          } else {
            localStorage.setItem("jwt_token", res.token);
            const safeUser = {
              _id: res.user._id,
              email: res.user.email,
              fname: res.user.fname,
              lname: res.user.lname,
              phone: res.user.phone,
              address: res.user.address,
              discount: res.user.discount,
              loginCount: res.user.loginCount,
              userRole: res.user.userRole,
              imageUrl: res.user.imageUrl, // if available
            };
            localStorage.setItem("user", JSON.stringify(safeUser));
            window.dispatchEvent(new Event("userLoggedIn"));
            this.incrementLoginCount(safeUser);
            this.props.handleClose();
          }
        })
        .catch((err) => {
          this.setState({ modalShowErr: true });
        });
    }
    event.preventDefault();
    event.stopPropagation();
  };

  joinClick = () => {
    this.props.handleClose();
    this.props.handleRegisterShow();
  };

  incrementLoginCount(user) {
    const newCount = user.loginCount + 1;
    updateAccount({ ...user, loginCount: newCount }, user._id)
      .then((res) => {})
      .catch((err) => {});
  }

  responseGoogle = async (response) => {
    const profileObj = response.profileObj;
    this.setState({ imageUrl: profileObj.imageUrl });
    await register(profileObj)
      .then((res) => {
        profileObj._id = res._id;
        profileObj.fname = profileObj.givenName;
      })
      .catch((e) => {
        this.errResponseGoogle(e);
      });
    localStorage.setItem("user", JSON.stringify(profileObj));
    this.props.handleClose();
  };

  errResponseGoogle = (response) => {
    toast.error("Unable to Sign in with Google !");
  };

  render() {
    const img = this.state.imageUrl ? (
      <Image
        src={this.state.imageUrl}
        width="80"
        roundedCircle
        className="mb-3"
      />
    ) : (
      <Image
        src={require("../images/login.png")}
        width="80"
        roundedCircle
        className="mb-3"
      />
    );
    return (
      <Modal
        show={this.props.showLogin}
        onHide={this.props.handleClose}
        centered
      >
        <Form onSubmit={(e) => this.handleSubmit(e)}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100 text-center">Sign In</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex flex-column align-items-center">{img}</div>
            <Form.Group controlId="formBasicEmail" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="username"
                placeholder="Enter email"
                size="lg"
                autoFocus
                onChange={this.handleChange("username")}
                style={{ marginBottom: 16 }}
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword" className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Enter Password"
                size="lg"
                onChange={this.handleChange("password")}
                style={{ marginBottom: 16 }}
              />
            </Form.Group>
            {this.state.modalShowErr && (
              <Alert variant={"danger"}>{this.state.modalErrMsg}</Alert>
            )}
            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-2"
              size="lg"
            >
              Sign in
            </Button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <span>Don't have an account?</span>
            <Button
              variant="outline-primary"
              className="ml-2"
              onClick={this.joinClick}
              size="lg"
            >
              Register
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default Login;
